// extracted by mini-css-extract-plugin
export default {"dataItem":"DataItem_dataItem__jESpx","title":"DataItem_title__z1DUj","value":"DataItem_value__lgkwC"};